import axios from "axios"
import { getToken } from "./token"
import { config } from '@/config'


let url = config.apihost

const http = axios.create({
    baseURL: url,//接口环境
    timeout: 5000,
})

// 请求拦截器
http.interceptors.request.use((config) => {
    // 一存多用 token注入
    const token = getToken()
    if (token) {
        config.headers.coopToken = token
    }
    return config
}, (error) => {
    return Promise.reject(error)
})

//响应拦截器
http.interceptors.response.use((response) => {
    if (response.data.msg === "token无效") {
        window.location.href = '/Login'
    }
    return response
}, (error) => {
    return Promise.reject(error)
})

export { http }